"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateHasError = exports.stateHasData = exports.fetchIdle = exports.fetchSuccess = exports.fetchError = exports.fetchLoading = exports.FetchStateType = void 0;
/*
 * these are just helpers for formatting responses, they don't actually do any loading. especially in UI development they
 * help with continuity over loading, reloading, saving, and errors. this is pretty nice in typescript because you have to deal
 * with the possibility that the result state is in a loading or error state. if you avoid dealing with those states you need
 * to write very clear code to ignore them, which easily presents missing functionality like errors that are not being messaged
 * to the user.
 * */
var FetchStateType;
(function (FetchStateType) {
    FetchStateType["SUCCESS"] = "success";
    FetchStateType["ERROR"] = "error";
    FetchStateType["LOADING"] = "loading";
    FetchStateType["IDLE"] = "idle";
})(FetchStateType = exports.FetchStateType || (exports.FetchStateType = {}));
/*
 * keeps existing data but sets the new status
 *
 * const state = fetchLoading(previousState)
 * */
const fetchLoading = (previous) => ({ type: FetchStateType.LOADING, ...(previous && 'data' in previous ? { data: previous.data } : {}) });
exports.fetchLoading = fetchLoading;
/*
 * keeps existing data but sets the new status and error value
 *
 * const state = fetchError(error, previousState)
 * */
const fetchError = (error, previous) => ({ ...previous, type: FetchStateType.ERROR, error });
exports.fetchError = fetchError;
/*
 * formats data with success type
 *
 * const state = fetchSuccess(newData)
 * */
const fetchSuccess = (data) => ({ type: FetchStateType.SUCCESS, data });
exports.fetchSuccess = fetchSuccess;
/*
 * formats data with idle type
 *
 * const state = fetchIdle(newData)
 * */
const fetchIdle = () => ({ type: FetchStateType.IDLE });
exports.fetchIdle = fetchIdle;
/*
 * guard for checking if the state has result data, it might be true for any state type.
 * */
const stateHasData = (state) => 'data' in state;
exports.stateHasData = stateHasData;
/*
 * guard for checking if the state has an error, it might be true for error or loading states.
 * */
const stateHasError = (state) => 'error' in state;
exports.stateHasError = stateHasError;
